import { render } from "./ModalsDropDown.vue?vue&type=template&id=85924d4a"
import script from "./ModalsDropDown.vue?vue&type=script&lang=js"
export * from "./ModalsDropDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__